import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { reducerPaths } from "../../../../../packages/common/src/app/reducerPaths";
import { baseQueryWithAuth } from "../../../../../packages/common/src/toolkit/methods/baseQueryWithAuth";

export const walletAndPaymentsApi = createApi({
  reducerPath: reducerPaths.walletAndPaymentsApi, // Unique key in Redux store
  baseQuery: baseQueryWithAuth,
  endpoints: (builder) => ({
    walletDeposit: builder.mutation({
      query: ({ payload }) => ({
        url: `/buyer/wallet/deposit`,
        method: "POST",
        body: payload
      }),
    }),
    walletWithdraw: builder.mutation({
      query: ({ payload }) => ({
        url: `/buyer/wallet/withdraw`,
        method: "POST",
        body: payload
      }),
    }),
    currencyConversion: builder.query({
      query: ({ payload }) => {
        return {
          url: `/buyer/payment/confirmation/page`,
          method: "POST",
          body: payload
        }
      }
    }),
    addFundsConfirmation: builder.mutation({
      query: ({ payload }) => ({
        url: `/buyer/addFundsConfirmationAPI`,
        method: "POST",
        body: payload
      }),
    }),
    getSubAccount: builder.query({
      query: ({}) => {
        return {
          url: `/buyer/getSubaccount`,
          method: "GET"
        }
      }
    }),
    getWalletTransactions: builder.query({
      query: ({ params = {}, payload }) => {
        return {
          url: `/buyer/wallet/transactions/list`,
          method: "GET",
          body: payload,
          params
        }
      }
    })
  }),
});

export const {
  useWalletDepositMutation,
  useWalletWithdrawMutation,
  useAddFundsConfirmationMutation,
  useLazyGetWalletTransactionsQuery,
  useLazyCurrencyConversionQuery,
  useLazyGetSubAccountQuery
} = walletAndPaymentsApi;